import { isFormValid } from "../../FormValidation/index";
import { withHandlers } from "recompose";
import getConfig from "./config";

const withFormHandlers = withHandlers({
  onSubmit: (props) => (event) => {
    event.preventDefault();

    if (isFormValid(props, getConfig(props))) {
      props.history.push(`/application/thank-you`);
    }
  },
});

export default withFormHandlers;
